import { render, staticRenderFns } from "./InviteGift.vue?vue&type=template&id=8cb4f7a0&scoped=true"
import script from "./InviteGift.vue?vue&type=script&lang=ts"
export * from "./InviteGift.vue?vue&type=script&lang=ts"
import style0 from "./InviteGift.vue?vue&type=style&index=0&id=8cb4f7a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cb4f7a0",
  null
  
)

export default component.exports